export * from './prev-icon.component';